const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || 'godiway-350020';

export const isFirebaseEnabled = () =>
    process.env.REACT_APP_FIREBASE_ENABLED === 'true' &&
    !!process.env.REACT_APP_FIREBASE_API_KEY &&
    !!process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID &&
    !!process.env.REACT_APP_FIREBASE_APP_ID &&
    !!process.env.REACT_APP_FIREBASE_VAPID_KEY;

export const firebaseWebConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain:
        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
        `${projectId}.firebaseapp.com`,
    projectId,
    storageBucket:
        process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
        `${projectId}.appspot.com`,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const firebaseVapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;
